<template>
    <edit-dialog title="新增应用" :show="visible" @close="onClose" width="500px">
        <el-form size="mini" :model="form" label-width="100px" :rules="rules" ref="form">
            <el-form-item prop="AppName" label="应用名称">
                <el-input v-model="form.AppName"></el-input>
            </el-form-item>
            <el-form-item prop="TenantID" label="所属租户">
                <el-select style="width: 100%" v-model="form.TenantID">
                    <el-option v-for="item of tenantList" :key="item.TenantID" :label="item.TenantName" :value="item.TenantID"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="MinInterval" label="接口最小调用间隔">
                <el-input-number style="width: 100%" :precision="0" v-model="form.MinInterval" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
        </el-form>
        <template v-slot:button>
            <el-button size="mini" type="primary" @click="saveData"> 保存 </el-button>
            <el-button size="mini" @click="onClose"> 取消 </el-button>
        </template>
    </edit-dialog>
</template>

<script>
export default {
    name: "EditApp",
    props: {
        visible: { type: Boolean, default: false },
    },
    data() {
        return {
            tenantList: [],
            form: {
                TenantID: "",
                AppName: "",
                MinInterval: 0,
            },
            rules: {
                TenantID: [{ required: true, message: "必填项", trigger: "blur" }],
                AppName: [{ required: true, message: "必填项", trigger: "blur" }],
                MinInterval: [{ required: true, message: "必填项", trigger: "blur" }],
            },
        };
    },
    methods: {
        getTenantList() {
            let params = {
                Key: "",
                PageIndex: 1,
                PageSize: 200000,
            };
            this.$ajax.post("/Platform/GetTenantList", params).then((res) => {
                if (res.Data) {
                    this.tenantList = res.Data;
                }
            });
        },
        saveData() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$ajax.post("/Platform/CreateApp", this.form).then((res) => {
                        this.$success("操作成功");
                        this.$emit("refresh", true);
                        this.onClose();
                    });
                }
            });
        },
        onClose() {
            this.$emit("update:visible", false);
        },
    },
    created() {
        this.getTenantList();
    },
};
</script>

<style scoped></style>
